import type { useTranslation } from "react-i18next";

import { HttpError, HTTP_UNPROCESSABLE_ENTITY } from "./api";

// Человекочитаемый текст серверной ошибки мутации шаблона: 422 →
// `detail` валидатора (или fallback), любой другой код / не-HttpError →
// generic-ключ. Общий для org- и repo-секций.
export function serverErrorText(
  error: Error,
  t: ReturnType<typeof useTranslation>["t"],
): string {
  if (
    error instanceof HttpError &&
    error.status === HTTP_UNPROCESSABLE_ENTITY
  ) {
    return error.detail ?? t("branchNameTemplate.serverError.invalid");
  }
  return t("branchNameTemplate.serverError.generic");
}
